var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 2.5,
    fill: "white",
    stroke: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 2.5,
    fill: "white",
    stroke: "var(--primary-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5279 6.58417L16.5279 6.58418L8.53345 14.8379L5.47186 11.6782C5.16941 11.3659 4.67593 11.3659 4.37349 11.6782C4.07537 11.9859 4.07537 12.4814 4.37349 12.7892L7.98389 16.5163C8.12855 16.6656 8.32629 16.75 8.53348 16.75C8.74101 16.75 8.93799 16.6653 9.08253 16.5151C9.08268 16.515 9.08283 16.5148 9.08297 16.5147L17.6263 7.69518C17.9244 7.38743 17.9244 6.89193 17.6263 6.58417C17.3239 6.27195 16.8304 6.27195 16.5279 6.58417Z",
    fill: "var(--primary-color)",
    stroke: "var(--primary-color)",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheckbox);
export default __webpack_public_path__ + "static/media/selected-checkbox.341b7d3b345d178b5d68b7277fd5d59d.svg";
export { ForwardRef as ReactComponent };